import BeatHeading from "./BeatHeading"

export { BeatHeading }
